import { memo } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix Leaflet marker icons with Vite
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Configure default marker icon
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
});

interface AppointmentMapProps {
  lat: number;
  lng: number;
  locationName: string;
  interactive?: boolean;
  className?: string;
}

function AppointmentMapComponent({
  lat,
  lng,
  locationName,
  interactive = false,
  className = '',
}: AppointmentMapProps) {
  // Validate coordinates
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
    return (
      <div className={`rounded-lg bg-gray-100 p-4 text-sm text-gray-600 ${className}`}>
        Invalid location coordinates
      </div>
    );
  }

  try {
    return (
      <div className={`rounded-lg overflow-hidden ${className}`}>
        <MapContainer
          center={[lat, lng]}
          zoom={15}
          scrollWheelZoom={interactive}
          dragging={interactive}
          touchZoom={interactive}
          doubleClickZoom={interactive}
          zoomControl={interactive}
          className="h-full w-full"
          style={{ minHeight: '120px' }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={[lat, lng]}>
            <Popup>{locationName}</Popup>
          </Marker>
        </MapContainer>
      </div>
    );
  } catch (error) {
    // Fallback if map fails to render
    return (
      <div className={`rounded-lg bg-gray-100 p-4 text-sm text-gray-600 ${className}`}>
        Unable to display map. Location: {locationName}
      </div>
    );
  }
}

// Memoize to prevent unnecessary re-renders
export const AppointmentMap = memo(AppointmentMapComponent);
